// 集患サポート系
export function getAppointmentTopPath(medicalInstitutionId: string): string {
  return `/medical_institution/${medicalInstitutionId}/booking`;
}

export function getAppointmentVisitDatePath(medicalInstitutionId: string): string {
  return `/medical_institution/${medicalInstitutionId}/booking/visit-date`;
}

export function getAppointmentTelPath(medicalInstitutionId: string, isToday = false): string {
  return `/medical_institution/${medicalInstitutionId}/booking/tel-appointment?${isToday ? 'is_today_visit=1' : ''}`;
}

export function getAppointmentPersonalInformationPath(medicalInstitutionId: string): string {
  return `/medical_institution/${medicalInstitutionId}/booking/personal-information`;
}

export function getAppointmentCompletePath(medicalInstitutionId: string): string {
  return `/medical_institution/${medicalInstitutionId}/booking/complete`;
}

export function getAppointmentTelCompletePath(medicalInstitutionId: string): string {
  return `/medical_institution/${medicalInstitutionId}/booking/tel-appointment-complete`;
}

// 薬局予約
export {
  getPharmacyBookingLandingPath,
  getPharmacyBookingEmailPath,
  getPharmacyBookingOtpPath,
  getPharmacyBookingFormPath,
  getPharmacyBookingManagePath,
} from '~/features/pharmacy-booking/routes';
